import type { ComponentSchema } from "../../../../../schema-types"

const CHANNEL_ICONS = ['phone', 'whatsapp', 'messenger', 'mail', 'map-pin', 'store', 'clock'].map(value => ({ label: value.replace('-', ' '), value }))

export const schema: ComponentSchema = {
  type: 'contact',
  label: 'Contact Section',
  description: 'Contact page: channel cells, a location band with the address and a map, and a message form.',
  supportedPages: ['contact'],
  variants: [{ id: 'v1', label: 'Channels, location and form' }],
  commonFields: [
    { key: 'eyebrow', label: 'Eyebrow', type: 'localized-string', default: 'Pick a way in' },
    { key: 'title', label: 'Title', type: 'string', default: 'Get in' },
    { key: 'highlight', label: 'Highlighted words', type: 'localized-string', default: 'touch.', help: 'Shown in amber on their own line under the title.' },
    { key: 'description', label: 'Description', type: 'text', default: 'For the quickest help, keep your order number or phone number to hand when you get in touch.' },
    {
      key: 'channels',
      label: 'Channels',
      type: 'array',
      help: 'Leave empty to show your Store info phone, WhatsApp, email and address. A channel without a link goes to the phone, WhatsApp, email or location by its icon.',
      itemSchema: [
        { key: 'icon', label: 'Icon', type: 'select', options: CHANNEL_ICONS, default: 'phone' },
        { key: 'label', label: 'Small label', type: 'localized-string', placeholder: 'Call' },
        { key: 'title', label: 'Title', type: 'localized-string' },
        { key: 'text', label: 'Line', type: 'localized-text' },
        { key: 'linkText', label: 'Link text', type: 'localized-string', help: 'Empty: the phone number, email or a default text.' },
        { key: 'link', label: 'Link', type: 'string', placeholder: 'https://m.me/yourpage' },
      ],
      default: [
        { icon: 'phone', label: 'Call', title: 'Call us', text: 'Orders, sizes and delivery questions.' },
        { icon: 'whatsapp', label: 'WhatsApp', title: 'WhatsApp', text: 'Send a quick message to the team.', linkText: 'Chat on WhatsApp' },
        { icon: 'mail', label: 'Email', title: 'Email us', text: 'Bulk orders, partnerships and anything else.' },
        { icon: 'map-pin', label: 'Visit', title: 'Visit us', text: 'Try the fits in person at our store.', linkText: 'View location' },
      ],
    },
    { key: 'email', label: 'Email Address', type: 'string' },
    { key: 'phone', label: 'Phone Number', type: 'string' },
    { key: 'address', label: 'Physical Address', type: 'text', help: 'Empty: the addresses from Store info.' },
    { key: 'mapEyebrow', label: 'Location eyebrow', type: 'localized-string', default: 'Visit the store' },
    { key: 'mapTitle', label: 'Location headline', type: 'localized-string', default: 'Come see us at' },
    { key: 'mapOutline', label: 'Location outlined words', type: 'localized-string', default: 'the neighbourhood.', help: 'Drawn as outlines on their own line.' },
    { key: 'mapText', label: 'Location line', type: 'localized-text', default: 'Drop by to try the fits, pick up an order or swap a size. Calling before you come helps.' },
    { key: 'mapImage', label: 'Map picture', type: 'image', help: 'Optional: a picture of your map, about 4:3. Without one the address is shown in the frame.' },
    { key: 'mapLink', label: 'Map link', type: 'string', placeholder: 'https://maps.app.goo.gl/…', help: 'Empty: a map search for the first address.' },
    { key: 'mapLinkText', label: 'Map link text', type: 'localized-string', default: 'Open in maps' },
    { key: 'formEyebrow', label: 'Form eyebrow', type: 'localized-string', default: 'Send a message' },
    { key: 'formTitle', label: 'Form headline', type: 'localized-string', default: 'Tell us what' },
    { key: 'formHighlight', label: 'Form highlighted words', type: 'localized-string', default: 'you need.' },
    { key: 'formText', label: 'Form line', type: 'localized-text', default: 'Leave your name, a way to reach you and your message, and we will get back to you soon.' },
  ],
}
